module.exports = __webpack_public_path__ + "img/roundUpload.b5195f16.svg";